<script>
export default {
  name: "privacyPolicy"
}
</script>

<template>
  <div class="privacy-container">
    <div class="privacy-content">
      <h2>易比图工具隐私政策</h2>
      <p class="version-date"><strong>版本日期：2025年8月26日</strong></p>
      <p class="intro">本隐私政策旨在说明本公司在您使用本软件及相关服务过程中，如何收集、使用、存储和保护您的个人信息。</p>

      <h3>1. 信息收集</h3>
      <ul>
        <li><strong>注册信息</strong>：包括姓名、邮箱、联系电话等（如适用）。</li>
        <li><strong>使用数据</strong>：包括软件功能使用频率、比对任务类型、错误日志（不含比对图片内容本身）。</li>
        <li><strong>设备信息</strong>：包括操作系统类型、版本号、硬件型号等。</li>
      </ul>

      <h3>2. 信息使用</h3>
      <ul>
        <li>提供、维护和优化本软件的功能与性能。</li>
        <li>为用户提供技术支持与更新通知。</li>
        <li>在用户同意的情况下，用于发送产品资讯或营销活动信息。</li>
      </ul>

      <h3>3. 信息存储与保护</h3>
      <ul>
        <li>本公司采取符合行业标准的安全措施保护用户数据，防止未经授权的访问、披露、篡改或毁坏。</li>
        <li>除法律法规另有规定外，本公司仅在为实现本政策所述目的所必需的期限内保存用户信息。</li>
      </ul>

      <h3>4. 信息共享</h3>
      <ul>
        <li>本公司不会向第三方出售或出租用户信息。</li>
        <li>仅在以下情况下共享用户信息：
          <ul class="nested-list">
            <li>获得用户事先同意；</li>
            <li>法律法规或政府机关要求；</li>
            <li>为维护本公司合法权益所必需。</li>
          </ul>
        </li>
      </ul>

      <h3>5. 用户权利</h3>
      <ul>
        <li>用户可随时访问、更正或删除其个人信息（法律法规另有规定的除外）。</li>
        <li>用户可撤回同意，但可能会影响某些功能的使用。</li>
      </ul>

      <h3>6. 政策更新</h3>
      <ul>
        <li>本公司可能会不时更新本政策，并通过官网或其他适当方式通知用户。</li>
        <li>更新后的政策自发布之日起生效。</li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.privacy-container {
  max-width: 820px;
  margin: 0 auto;
  padding: 32px 20px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
  color: #334155;
  line-height: 1.7;
}

.privacy-content {
  background: #ffffff;
  padding: 44px 48px;
  border-radius: 20px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.06), 0 2px 8px rgba(47, 91, 255, 0.04);
  position: relative;
  overflow: hidden;
}

h2 {
  color: #0f172a;
  text-align: center;
  margin: 0 0 12px 0;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(241, 245, 249, 0.9);
  font-size: 1.75rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  background: #000;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.version-date {
  text-align: center;
  color: #94a3b8;
  margin: 0 0 28px 0;
  font-size: 0.86rem;
}

.version-date strong {
  color: #64748b;
  font-weight: 600;
}

.intro {
  font-size: 0.95rem;
  margin-bottom: 32px;
  color: #475569;
  background: linear-gradient(135deg, rgba(47, 91, 255, 0.05), rgba(245, 158, 11, 0.03));
  padding: 18px 20px;
  border-radius: 12px;
  border-left: 4px solid;
  border-image: linear-gradient(180deg, #2f5bff, #f59e0b) 1;
  line-height: 1.8;
}

h3 {
  color: #1e293b;
  margin: 28px 0 14px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(241, 245, 249, 0.9);
  font-size: 1.15rem;
  font-weight: 700;
  position: relative;
  padding-left: 14px;
}

h3::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: linear-gradient(180deg, #2f5bff, #f59e0b);
}

ul {
  padding-left: 22px;
  margin-bottom: 24px;
}

li {
  margin-bottom: 10px;
  color: #475569;
  position: relative;
  font-size: 0.92rem;
  line-height: 1.8;
}

.nested-list {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 20px;
}

.nested-list li {
  margin-bottom: 6px;
  font-size: 0.88rem;
  color: #64748b;
}

strong {
  color: #1e293b;
  font-weight: 600;
}

@media (max-width: 768px) {
  .privacy-container {
    padding: 16px 12px;
  }

  .privacy-content {
    padding: 28px 22px;
  }

  h2 {
    font-size: 1.4rem;
  }

  h3 {
    font-size: 1.02rem;
  }

  .intro {
    padding: 14px 16px;
    font-size: 0.9rem;
  }

  li {
    font-size: 0.88rem;
  }
}
</style>
